import type { ReactElement } from 'react';

export interface IParseGradientReturn {
  angleOrDirection?: string;
  stops: ({ color: string; offset: string } | undefined)[];
}

const parseCSSGradient = (gradient: string): IParseGradientReturn | void => {
  const linearGradientRegex = /linear-gradient\((.+)\)/;
  let gradientData;

  if (linearGradientRegex.test(gradient)) {
    const matches = linearGradientRegex.exec(gradient);

    if (matches?.[1]) {
      gradientData = matches[1].split(', ').map((item) => item.trim());

      const angleOrDirection = gradientData.shift();
      const stops = gradientData.map((stop) => {
        const [color, offset] = stop.split(' ').filter(Boolean);

        if (color && offset) {
          return { color, offset };
        }
      });

      return { angleOrDirection, stops };
    }
  }
};
export interface ICalculateLinearGradientCoordsReturn {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

const calculateLinearGradientCoords = (angle: number): ICalculateLinearGradientCoordsReturn => {
  const radians = (angle * Math.PI) / 180;
  const x1 = Math.round(50 + 50 * Math.cos(radians));
  const y1 = Math.round(50 + 50 * Math.sin(radians));
  const x2 = Math.round(50 - 50 * Math.cos(radians));
  const y2 = Math.round(50 - 50 * Math.sin(radians));

  return { x1, y1, x2, y2 };
};

export const CSSGradientToSVG = (gradientString: string, id: string): ReactElement | null => {
  const gradientData = parseCSSGradient(gradientString);
  if (!gradientData) {
    return null;
  }

  const { angleOrDirection = '', stops } = gradientData;
  let angle = 0;

  switch (angleOrDirection) {
    case '':
    case 'to bottom':
      angle = 180;
      break;
    case 'to right':
      angle = 90;
      break;
    case 'to left':
      angle = 270;
      break;
    case 'to top':
      break;
    default:
      if (angleOrDirection.includes('deg')) {
        angle = parseFloat(angleOrDirection);
      }
      break;
  }

  const { x1 = 0, y1 = 0, x2 = 100, y2 = 100 } = calculateLinearGradientCoords(angle);

  const stopsGradient: ReactElement[] = [];
  stops.forEach((stop, index) => {
    if (!stop) return;

    stopsGradient.push(
      <stop key={stop.offset} offset={stop.offset || `${(index / (stops.length - 1)) * 100}%`} stopColor={stop.color} />
    );
  });

  return (
    <linearGradient id={id} x1={`${x1}%`} y1={`${y1}%`} x2={`${x2}%`} y2={`${y2}%`}>
      {stopsGradient}
    </linearGradient>
  );
};

export const getDefaultGradient = (gradientID: string): ReactElement => {
  return (
    <linearGradient id={gradientID}>
      <stop stopColor="#DEBE44" />
      <stop offset="0.25" stopColor="#395CB6" />
      <stop offset="0.50" stopColor="#CE4C92" />
      <stop offset="0.75" stopColor="#B5385A" />
      <stop offset="1" stopColor="#F2B865" />
    </linearGradient>
  );
};
